import { apiClientV2 } from '@/services/rest-api/apiClient'

const baseURL = process.env.VUE_APP_API_VMS_URL

export const get = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/additional-cost',
    params: params,
  })

  return response?.data
}

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/additional-cost/${id}`,
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/additional-cost',
    data,
  })

  return response?.data
}

export const update = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/additional-cost/${id}`,
    data,
  })

  return response?.data
}

export const deleteMany = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/additional-cost/delete`,
    data
  })

  return response?.data
}
